export const SYNCING = 'syncing';
export const SET_SETTINGS = 'set_settings';
export const SET_ERROR = 'error_data';
export const RESET = 'reset';
